import { gql } from "apollo-boost";

export const BALANCE = gql(`
	query balance($investorAccountID: String!) {
		balance(investorAccountID: $investorAccountID) {
			__typename
			... on BalanceOutput {
				portValue
				subscriptionReturn
				accountInformation {
					cashBalance
					creditLimit
					lineAvailable
				}
				currentPositions {
					symbol
					volume
					costPrice
					marketPrice
					unrealizedPL
					pctUnrealizedProfit
				}
			}
			... on Error {
				code
				message
			}
		}
	}
`);

export const PORT_VALUE = gql`
	query portValue($investorAccountID: String!) {
		portValue(investorAccountID: $investorAccountID) {
			__typename
			... on PortValueOutput {
				portValue
			}
			... on Error {
				code
				message
			}
		}
	}
`;

export const BITKUB_BALANCE = gql(`
	query bitkubPortfolio {
		bitkubPortfolio {
			__typename
			... on BitkubPortfolioOutput {
				portValue
				totalCash
				availableCash
				balances {
					currency
					available
					total
					value
					lastPrice
				}
			}
			... on Error {
				code
				message
			}
		}
	}
`);